(function($) {
    $(document).ready(function() {

        // кнопка показать скрыть под таблицей
        $('.node-type--software .field--name-field-custom-code-html .item_btn_more').click(function() {
            $(this).toggleClass('active');
            $('.node-type--software .field--name-field-custom-code-html .item_wrapper .content_row').toggleClass('show-row');
            if(this.classList.contains("active")) {
                $(this).text("Скрыть");
            }else{
                $(this).text("Полный список");
            }
        });

        // кнопки описания сверху - возможности, характеристики и тд...
        const TabsTitles = document.querySelectorAll(".software_readmore");
        TabsTitles.forEach((TabsTitle) => {
            TabsTitle.addEventListener("click", () => {
                if (TabsTitle.classList.contains("active")) {
                    TabsTitle.classList.remove("active");
                } else {
                    const TabsTitlesActive = document.querySelectorAll(".active");
                    TabsTitlesActive.forEach((TabsTitlesActive) => {
                        TabsTitlesActive.classList.remove("active");
                    });
                    TabsTitle.classList.add("active");
                }
            });
        });
        if (document.getElementById("software_desc_body")) {
            $('#software_desc').addClass('show_btn')
        }
        if (document.getElementById("software_feat_body")) {
            $('#software_feat').addClass('show_btn')
        }
        if (document.getElementById("software_spec_body")) {
            $('#software_spec').addClass('show_btn')
        }
        if (document.getElementById("software_supp_body")) {
            $('#software_supp').addClass('show_btn')
        }
        if (document.getElementById("software_data_body")) {
            $('#software_data').addClass('show_btn')
        }

        // скрыть кнопку купить после клика
        $('.button--add-to-cart').mousedown(function() {
            ym(102417570, "reachGoal", "webit_addToCart");
            $(this).addClass('disabled');
            //$(this).closest('.cart-box').find('a').addClass('xxx');
            $('.cart--cart-block').removeClass('cart-empty');
        });

        // custom offer title for custom services-soft
        $(".node-75 .block--programm-offer").find(".field--name-field-paragraph-title").html("Хотите внедрить Клеверенс Склад&nbsp;15?");
        $(".node-75 .block--software-block-desc").find("#software_desc").html("Совместимость");
        $(".node-76 .block--programm-offer").find(".field--name-field-paragraph-title").html("Хотите внедрить Клеверенс Магазин&nbsp;15?");
        $(".node-76 .block--software-block-desc").find("#software_feat").html("Совместимость");
        $(".node-93 .block--software-block-desc").find("#software_feat").html("Кому подходит");
        $(".node-93 #paragraph-id--303").find(".item_ttl").html("Затрудняетесь при&nbsp;выборе");
        $(".node-93 #paragraph-id--303").find(".item_txt").html("Проанализируем ваши бизнес-задачи и&nbsp;подберем подходящие решения из&nbsp;экосистемы&nbsp;1С");
        $(".node-93 #paragraph-id--302").find(".item_ttl").html("Оставьте заявку на&nbsp;консультацию");
        $(".node-93 #paragraph-id--302").find(".item_txt").html("Подберем приложение под&nbsp;ваши задачи и&nbsp;оптимальный тариф без&nbsp;переплат");
    });
})(jQuery);